/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Start_ConversationInputs */

const en_failed_to_start_conversation = /** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start conversation`)
};

const es_failed_to_start_conversation = /** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar la conversación`)
};

const fr_failed_to_start_conversation = /** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du démarrage de la conversation`)
};

const de_failed_to_start_conversation = /** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat konnte nicht gestartet werden`)
};

const id_failed_to_start_conversation = /** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memulai percakapan`)
};

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const ja_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const zh_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const ar_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const it_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const ru_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const pt_failed_to_start_conversation = en_failed_to_start_conversation;

/** @type {(inputs: Failed_To_Start_ConversationInputs) => LocalizedString} */
const ko_failed_to_start_conversation = en_failed_to_start_conversation;

/**
* | output |
* | --- |
* | "Failed to start conversation" |
*
* @param {Failed_To_Start_ConversationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_start_conversation = /** @type {((inputs?: Failed_To_Start_ConversationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Start_ConversationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_start_conversation(inputs)
	if (locale === "es") return es_failed_to_start_conversation(inputs)
	if (locale === "fr") return fr_failed_to_start_conversation(inputs)
	if (locale === "de") return de_failed_to_start_conversation(inputs)
	if (locale === "ja") return ja_failed_to_start_conversation(inputs)
	if (locale === "zh") return zh_failed_to_start_conversation(inputs)
	if (locale === "ar") return ar_failed_to_start_conversation(inputs)
	if (locale === "id") return id_failed_to_start_conversation(inputs)
	if (locale === "it") return it_failed_to_start_conversation(inputs)
	if (locale === "ru") return ru_failed_to_start_conversation(inputs)
	if (locale === "pt") return pt_failed_to_start_conversation(inputs)
	return ko_failed_to_start_conversation(inputs)
});